import React from "react";
import { Box, Divider, Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import HelpTooltip from "@/shared/components/help-tooltip";
import { Trans } from "react-i18next";
import SummaryCardList, {
  SummaryItem,
} from "@/shared/components/SummaryCardList";

interface Props {
  unRemittedCount: number;
  remittedAmount: number;
  // 바이어 유로 송금 프로포마로 송금 완료한 유로 금액
  remittedEurAmount?: number;
  expectedAdjustmentReturn: number;
}

function OrderHistoryInvoiceSummary({
  unRemittedCount,
  remittedAmount,
  remittedEurAmount = 0,
  expectedAdjustmentReturn,
}: Props) {
  const { tTitle, tCurrencyKrw, tCurrencyString, isKor } = useI18nHelper();
  const remittedLabel = [
    remittedAmount || !remittedEurAmount ? tCurrencyKrw(remittedAmount) : null,
    remittedEurAmount
      ? tCurrencyString(remittedEurAmount, { type: "SYMBOL", code: "EUR" })
      : null,
  ]
    .filter(Boolean)
    .join(" + ");

  const summaryList: SummaryItem[] = [
    {
      title: tTitle("order_history:invoice.remittance_required"),
      value: unRemittedCount + (isKor ? "건" : ""),
      textColor: unRemittedCount > 0 ? "#CC1D1D" : "#444444",
      backgroundColor: unRemittedCount > 0 ? "#FFEEEE" : "inherit",
    },
    {
      title: tTitle("order_history:invoice.difference_refund_scheduled"),
      value: expectedAdjustmentReturn + (isKor ? "건" : ""),
      tooltipContent: "order_history:invoice.difference_tooltip",
      textColor: expectedAdjustmentReturn > 0 ? "#1272EF" : "#444444",
    },
    {
      title: tTitle("order_history:invoice.remittance_completed_amount"),
      value: remittedLabel,
      textColor: remittedAmount > 0 || remittedEurAmount > 0 ? "#1272EF" : "#444444",
    },
  ];

  return <SummaryCardList summaryList={summaryList} />;
}

export default OrderHistoryInvoiceSummary;
